module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_7016.2c64ca9b.png";